import apiClient from '../lib/apiClient';

const toQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      query.set(key, String(value));
    }
  });
  const suffix = query.toString();
  return suffix ? `?${suffix}` : '';
};

const freepikService = {
  async searchIcons(params = {}) {
    const url = `/freepik/search${toQuery(params)}`;

    try {
      const { response, data } = await apiClient.request(url, { auth: false, meta: true });
      if (!response?.ok || !data?.success) {
        return { success: false, items: [], page: 1, has_more: false, message: 'Não foi possível carregar ícones' };
      }

      return {
        success: true,
        items: Array.isArray(data.items) ? data.items : [],
        page: Number(data.page || 1),
        has_more: Boolean(data.has_more),
      };
    } catch {
      return { success: false, items: [], page: 1, has_more: false, message: 'Não foi possível carregar ícones' };
    }
  },
};

export default freepikService;
